module.exports = __webpack_public_path__ + "static/screen_12-f9821a774880b270f3d0e661051b90b4.png";